/**
 * 判断字符串是否为有效 JSON。
 */
export const isValidJSON = (text: string): boolean => {
  try {
    JSON.parse(text);
    return true;
  } catch {
    return false;
  }
};
